/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import MuiDialog, { dialogClasses } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { globalTheme } from '../../theme';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { colorPalette } from '../../colorPalette';
import { useBreakpoint } from '@next-common/breakpoint';
const Transition = React.forwardRef(function Transition(props, ref) {
    return React.createElement(Slide, Object.assign({ direction: "up", ref: ref }, props));
});
export const Dialog = ({ withCloseIcon, withGoBackIcon, breakpointFullscreen, children, open, dataQa, disableBackdropClick = false, title, sx, footer, onGoBack, onClose, PaperProps, padding = '16px', withTransition = false, hideBackdrop = false, }) => {
    const theme = globalTheme();
    const fullscreen = useMediaQuery(theme.breakpoints.down(breakpointFullscreen !== null && breakpointFullscreen !== void 0 ? breakpointFullscreen : 'sm'));
    const { md } = useBreakpoint();
    const isMobileOnly = md.mobile && !md.isEmbeddedInBuyerApp ? true : false;
    const onGoBackDefault = () => {
        if (onGoBack) {
            onGoBack();
        }
    };
    const handleOnClose = (_event, reason) => {
        if (disableBackdropClick) {
            if (reason !== 'backdropClick') {
                onClose();
            }
        }
        else {
            onClose();
        }
    };
    return (React.createElement(MuiDialog, { sx: Object.assign({ display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.4)', alignItems: 'center', justifyContent: 'flex-end', height: '100%', [`& .${dialogClasses.container}`]: {
                boxSizing: 'border-box',
                width: '100%',
                mozBoxSizing: 'border-box',
                height: isMobileOnly ? `${window.innerHeight - 16}px` : '100%',
            }, [`& .${dialogClasses.paper}`]: {
                borderRadius: { xs: isMobileOnly ? '16px 16px 0px 0px' : '8px', sm: '8px' },
            } }, sx), scroll: 'paper', open: open, onClose: handleOnClose, fullScreen: fullscreen, PaperProps: PaperProps, container: () => {
            const id = 'hpernova-class-wrapper';
            const hpernovaClassWrapper = document.getElementById(id);
            if (hpernovaClassWrapper) {
                return hpernovaClassWrapper;
            }
            const elemDiv = document.createElement('div');
            elemDiv.classList.add('_hy');
            elemDiv.id = id;
            document.body.appendChild(elemDiv);
            return elemDiv;
        }, "data-qa": dataQa !== null && dataQa !== void 0 ? dataQa : null, TransitionComponent: withTransition ? Transition : undefined, hideBackdrop: hideBackdrop },
        React.createElement(DialogTitle, null,
            React.createElement(Stack, { direction: "row", justifyContent: title || withGoBackIcon ? 'space-between' : 'flex-end', alignItems: "center" },
                withGoBackIcon ? (React.createElement(ArrowBackIosNewIcon, { sx: { cursor: 'pointer', color: colorPalette.gray700 }, onClick: onGoBackDefault })) : (React.createElement(Box, null)),
                typeof title === 'string' ? (React.createElement(Typography, { fontSize: "16px", fontWeight: 600 }, title)) : (title),
                withCloseIcon && React.createElement(CloseIcon, { sx: { cursor: 'pointer', color: colorPalette.gray700 }, onClick: onClose }))),
        React.createElement(DialogContent, { dividers: !!title, sx: {
                padding,
                overflowY: 'auto',
                overflowX: 'hidden',
            } },
            React.createElement(DialogContentText, { id: "scroll-dialog-description", tabIndex: -1 }, children)),
        footer && (React.createElement(DialogActions, { sx: {
                padding: '16px',
                width: '100%',
            } },
            React.createElement(Stack, { width: '100%', direction: "row", justifyContent: "center", spacing: 2 }, footer)))));
};
